<div class="manager-loader-wrapper-offcanvas" [class]="appS.navigationS.navigations[this.type + '.' + this.wrapper]?.step">
  <div class="spinner-border w-55px h-55px"></div>
</div>
